import React from 'react';

import { Resources } from '@ragu-components/ord-resources';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { DistributionListRead } from '@ragu-components/ord-types';

const DistributionListsList = React.lazy(async () => import('./DistributionListsList'));

export const distributionListsResource: OrdResourceProps = {
  key: Resources.distribution_lists,
  name: Resources.distribution_lists,
  list: <DistributionListsList />,
  hasShow: true,
  options: {},
  recordRepresentation: (record: DistributionListRead): string => record.name,
};
